export default __webpack_public_path__ + "static/media/rubik-v12-latin-700.59a71146.ttf";